import React from 'react'
import PageList from '../../../components/PageListAPI'
import { getWeldersEngineerList, deleteWeldersEngineerById } from '../../../api/welding.api'
import { useCan } from 'src/hooks/useCan';
import { SLUGS } from 'src/enum/permissions.enum';
export default function WeldersEngineerList(props) {
  const can = useCan()
  return <div className='App-paper'>
    <PageList
      name='welders-e-list'
      title='Список инженерно-технического персонала, занятого выполнением сварочных работ'
      columns={[
        { id: 'fullName', name: 'Фамилия, имя, отчество', },
        { id: 'education', name: 'Специальность и образование', },
        { id: 'jobTitle', name: 'Занимаемая должность', },
        { id: 'dateStart', name: 'Дата начала работы  на объекте', type: 'date', formatDate: 'DD.MM.YYYY' },
        { id: 'mark', name: 'Отметка  о прохождении аттестации  и дата', },
        { id: 'dateEnd', name: 'Дата  окончания работы  на объекте', type: 'date', formatDate: 'DD.MM.YYYY' },
      ]}
      createItem={can(SLUGS.PROJECT.WELDING.MANAGE)}
      deleteItem={can(SLUGS.PROJECT.WELDING.MANAGE)}
      loadAPI={{
        request: getWeldersEngineerList,
        querty: {
        },
        param: {
          id: props.match.params.idProject
        },
      }}
      click={false}
      deleteAPI={deleteWeldersEngineerById(props.match.params.idProject)}
      {...props}
    />
  </div>
}